import React, { useState } from 'react'

import { withRouter } from 'react-router-dom'
import { useSelector } from 'react-redux'
import codeyolo from '../../assets/img/codeyolo.png'


const NavBar = (props) => {

  const { is_logged_in, user_data } = useSelector(state => state.authReducer)

  const [state, setState] = useState({
    togglePenWindow: false,
    showYourProfile: false,
    id: '',
    user: '',
    search: false
  })

  const toggleNav = () => {
    setState({
      showNav: !state.showNav
    })
  }



  // const savePen = () => {
  //  if(is_logged_in && props.accessId === user_data.uid)
  //   return <Save savePen={props.savePen}/>
  // else return <div />
  // }

return (
      <div className='Nav'>
        <nav className='nav1'>

          <div className='Name mb-8'>
            <div className='Name-footer text-6xl text-white' flex flex-row>
              <img className='icon-footer' style={{
                width :  150,
                height : 150
              }} src={codeyolo} alt='' /> 
              <span>
                Widget
              </span>
              {/* <img className='icon-footer'  src={codeyolo} alt="" /> <span className="text-white font-serif"> Widget</span> */}
            </div>
          </div>
{/* 
          {is_logged_in && (
            <Link to="/profile" className="link">
              <div className='divProf'>
                <p className='Your'>YOUR</p>
                <h1 className='Prof'>Profile</h1>
                <div className='h-line'></div>
              </div>
            </Link>
          )}

          <Link to="/pens" className="link">
            <div className='divExp'>
              <h1 className='Exp'>EXPLORE</h1>
              <h1 className='Prof'>Pens</h1>
              <div className='p-line'></div>
            </div>
          </Link>

          <Link to='/About' className='link'>
            <div className='divColl'>
              <h1 className='Coll'>About</h1>
              <div className='coll-line'></div>
            </div>
          </Link> */}

          <div className='nav2'>
            {/* {savePen()} */}
          </div>
        </nav>
      </div>
    )
  }

export default withRouter(NavBar)


// WEBPACK FOOTER //
// ./src/components/NavBar/NavBar3.js